import {
  Avatar,
  ClickAwayListener,
  Divider,
  Drawer,
  makeStyles,
  Tooltip,
} from "@material-ui/core";
import React, {
  useCallback,
  useDeferredValue,
  useEffect,
  useState,
} from "react";
import ModelStatusChip from "./ModelStatusChip";
import restoreIcon from "../../../assets/images/restore.svg";
import DeleteIcon from "@material-ui/icons/Delete";
import moment from "moment";
import versionData from "../../../assets/mockData/mockVersion.json";
import WarningPopup from "./warningPopup";
import { injectIntlTranslation } from "@carrier-ecat/workflowui-globalfunctions";
import { injectIntl } from "react-intl";
import { constants } from "../../../constants/constants";

const ModelVersion = ({ modelData, selectedModel, intl }) => {
  const useStyles = makeStyles((theme) => ({
    paper: {
      position: "absolute",
      backgroundColor: theme.palette.background.paper,
      padding: theme.spacing(2),
      padding: "16px",
      marginTop: "56px",
      width: "93%",
      height: "100vh",
    },
    gridField: {
      marginBottom: "8px",
    },
    deleteBtn: {
      cursor: "pointer",
    },
  }));

  const classes = useStyles();
  const [modelDetails, setModelDetails] = useState(null);

  const [revertOpen, setrevertOpen] = useState(false);
  const [deletehOpen, setDeleteOpen] = useState(false);

  const [versionList, setVersionList] = useState(versionData);

  useEffect(() => {
    const [t = null] = modelData?.filter((x) => x.modelId === selectedModel);
    setModelDetails(t);
  }, [modelData, selectedModel]);

  const handleClickAway = (event) => {};

  const getInitials = (fullName) => {
    const nameArray = fullName.trim().split(" ");

    const initials = nameArray
      .map((name) => name.charAt(0).toUpperCase())
      .join("");

    return initials;
  };

  const handleRevertModel = useCallback(() => {
    setrevertOpen(true);
  }, []);

  const handleRevertModelClose = useCallback(() => {
    setrevertOpen(false);
  }, []);

  const handleDeleteModel = useCallback((data) => {
    setDeleteOpen(data);
  }, []);

  const handleDeleteModelClose = useCallback(() => {
    setDeleteOpen(false);
  }, []);

  const handleDeleteModelCall = useCallback(() => {
    // console.log("data: ", deletehOpen);
    const t = versionList.filter((x) => x.id !== deletehOpen.id);
    setVersionList(t);
    setDeleteOpen(false);
  }, [deletehOpen]);

  return (
    <>
      <ClickAwayListener onClickAway={handleClickAway}>
        <div style={styles.drawer}>
          <div style={styles.header}>
            <div style={{ ...styles.title, flex: "1" }}>{injectIntlTranslation(intl, "versionHistoryLabel" , constants.versionHistoryLabel)}</div>
            <div style={styles.subtitle}>{modelDetails?.modelName || "-"}</div>
          </div>

          <Divider style={{ marginBottom: "10px", marginTop: "5px" }} />

          {versionList.map((ele, i) => {
            return (
              <div style={styles.versionItem}>
                <div style={styles.versionInfo}>
                  <div style={styles.versionTitle}>{`${ele?.title || ""} - ${
                    ele?.version || ""
                  }`}</div>
                  <div
                    style={{
                      display: "flex",
                      gap: "10px",
                      flex: "1",
                      marginLeft: "15px",
                    }}
                  >
                    <div className="grid-action-item-icon-container">
                      <img
                        src={restoreIcon}
                        alt="copy"
                        onClick={handleRevertModel}
                        width={15}
                        style={{ cursor: "pointer" }}
                        className="grid-action-item-icon"
                      />
                    </div>
                    <div className="grid-action-item-icon-container">
                      <DeleteIcon
                        color="disabled"
                        fontSize="small"
                        style={{
                          width: "15px",
                          color: "black",
                          cursor: "pointer",
                        }}
                        onClick={() => handleDeleteModel(ele)}
                      />
                    </div>
                  </div>
                  <div>
                    <ModelStatusChip status={ele?.status} />
                  </div>
                </div>
                <div style={styles.versionDetails}>
                  <div style={{ display: "flex" }}>
                    <div style={styles.dateTime}>
                      {moment(new Date()).format("MM/DD - h:mm a")}
                    </div>

                    <Tooltip title={ele?.description || ""}>
                      <div
                        style={{
                          ...styles.description,
                          marginLeft: "15px",
                        }}
                      >
                        {ele?.description || ""}
                      </div>
                    </Tooltip>
                  </div>
                  <span style={styles.author}>
                    <Avatar
                      style={{
                        background: "#1891F6",
                        color: "white",
                        textTransform: "uppercase",
                        height: "15px",
                        width: "15px",
                        fontSize: "8px",
                      }}
                    >
                      {getInitials(ele?.author)}
                    </Avatar>
                    {ele?.author}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </ClickAwayListener>
      <WarningPopup
        open={revertOpen}
        onClose={handleRevertModelClose}
        title={"Restore Old Model Version"}
        description={"Are you sure you want to restore this model version?"}
        saveButtonLabel={"Restore"}
        onSave={handleRevertModelClose}
      />

      <WarningPopup
        open={deletehOpen}
        onClose={handleDeleteModelClose}
        title={"Delete Model Version"}
        description={
          "Are you sure you want to delete this model version?, this action cannot be undo...!"
        }
        saveButtonLabel={`${injectIntlTranslation(intl, "deleteBtnLabel" , constants.deleteBtnLabel)}`}
        onSave={handleDeleteModelCall}
      />
    </>
  );
}

export default injectIntl(ModelVersion)

const styles = {
  drawer: {
    width: "470px",
    padding: "20px",
    backgroundColor: "#fff",
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.2)",
    height: "100vh",
  },
  header: {
    display: "flex",
  },
  title: {
    display: "block",
    fontSize: "16px",
    fontWeight: "bold",
    marginBottom: "5px",
  },
  subtitle: {
    fontSize: "14px",
    color: "#666",
  },
  versionItem: {
    marginBottom: "25px",
  },
  versionInfo: {
    display: "flex",
    marginBottom: "5px",
  },
  versionTitle: {
    fontSize: "14px",
    fontWeight: "bold",
  },
  statusPublished: {
    fontSize: "12px",
    color: "white",
    backgroundColor: "green",
    padding: "2px 5px",
    borderRadius: "3px",
  },
  statusArchived: {
    fontSize: "12px",
    color: "white",
    backgroundColor: "#ccc",
    padding: "2px 5px",
    borderRadius: "3px",
  },
  versionDetails: {
    fontSize: "12px",
    color: "#666",
  },
  dateTime: {
    display: "block",
    marginBottom: "8px",
  },
  description: {
    display: "block",
    marginBottom: "3px",
    width: "70%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  author: {
    display: "flex",
    gap: "5px",
  },
};
